import axios, { AxiosError, AxiosRequestConfig } from "axios";
import HttpStatusCode from "types/HttpStatusCode.enum";
import auth from "./auth";
import {
  AuthProviderCallback,
  Client
} from "@microsoft/microsoft-graph-client";
import queryClient from "./queryClient";
import { persistor } from "context/store";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_ROOT
});

async function api(options: AxiosRequestConfig) {
  const token = await auth.getToken();
  client.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
  return client(options).catch(onError);
}

async function onError(error: AxiosError) {
  if (error.response?.status === HttpStatusCode.Unauthorized) {
    await persistor.purge();
    await auth.logout();
  } else if (error.response?.status === HttpStatusCode.Forbidden) {
    queryClient.invalidateQueries(["user-details"]);
  }

  return Promise.reject(error);
}

const authProvider = async (callback: AuthProviderCallback) => {
  const token = await auth.getGraphToken();
  callback(null, token.accessToken);
};

const graphClient = Client.init({ authProvider });

export { client, graphClient };
export default api;
